document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.m-product-card').forEach(card => {
    const swatchWrapper = card.querySelector('[data-pcard-variant-picker]');
    if (!swatchWrapper) return;

    const jsonEl = swatchWrapper.querySelector('script[type="application/json"]');
    if (!jsonEl) return;

    let variants;
    try {
      variants = JSON.parse(jsonEl.textContent);
    } catch (e) {
      return;
    }

    const observer = new MutationObserver(() => {
      const selected = swatchWrapper.querySelector(
        '.m-product-option--node__label[data-selected="true"]'
      );
      if (!selected) return;

      const color = selected.dataset.value;
      const matched = variants.find(v => v.option1 === color);
      if (!matched) return;

      const variantId = matched.id;

      // Update all product links
      card.querySelectorAll('a[href^="/products/"]').forEach(link => {
        const base = link.href.split('?')[0];
        link.href = `${base}?variant=${variantId}`;
      });

      // Update hidden inputs
      card.querySelectorAll('input[name="id"]').forEach(input => {
        input.value = variantId;
      });
    });

    observer.observe(swatchWrapper, {
      subtree: true,
      attributes: true,
      attributeFilter: ['data-selected']
    });
  });
});
